import { observer } from 'mobx-react-lite';
import Canvas from './Canvas';
import type { CanvasProps, CanvasValueProps } from './types';

export type { CanvasProps, CanvasValueProps };
export default observer(Canvas); // MANUAL OVERRIDE
